module.exports = __webpack_public_path__ + "img/accounts.monthly.7b716e1b.png";